import { getCookie, setJusbrasilCookie } from '@jusbrasil-web/shared-utils-cookies'

import { ONE_YEAR_IN_SECONDS } from '../constants'

const MANAGE_USERS_ITEMS_SEEN_COOKIE = 'manage_users_items_seen'

export const isManageUsersItemsSeen = (isB2BSelfService = false) => {
  if (!isB2BSelfService) return true

  return getCookie(null, MANAGE_USERS_ITEMS_SEEN_COOKIE) === 'true'
}

export const handleSetManageUsersItemsSeen = () => {
  setJusbrasilCookie(null, MANAGE_USERS_ITEMS_SEEN_COOKIE, 'true', {
    maxAge: ONE_YEAR_IN_SECONDS,
  })
}
